import axios from "axios/index";
import { dispatchError, API_BASE, config as ApiConfig } from "../api";

export default store => {
  return {
    $store: store,
    list() {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url: API_BASE + "/stores/"
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    search(text = "", options = null, params = {}) {
      this.$store.commit("loading", true);

      let url = "";

      if (Object.keys(params).length === 0) {
        params.order_by = "description";
      }
      if (options && options.limit && options.offset !== undefined) {
        params.offset = options.offset;
        params.limit = options.limit;
      }
      if (options && options.paginationUrl) {
        url = options.paginationUrl.replace(/^http:/, 'https:');
        params = {}
      } else {
        url = API_BASE + `/stores/?description__icontains=${text}`
      }

      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url: url,
          params
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    }
  };
};
